<dynamic-form
  [apiName]="apiName"
  [group]="formGroup"
  [areaName]="areaName"
  [label]="label"
  [model]="model"
  reportName="FaithKind"
  pathPreFix="HRM"
  (cancelChange)="cancel()"
  [columns]="columns"
  (submitChange)="save()">
</dynamic-form>
